import React from "react";
import clsx from "clsx";

import { DASH } from "common/constants";
import useStyles from "./styles";

export interface IRowData {
  label: string;
  value: string;
  united?: boolean;
}

interface IProps {
  data: IRowData;
}

const WorkoutAnalysisTableRow = (props: IProps) => {
  const { label, value, united = false } = props.data;

  const classes = useStyles();

  return (
    <div className={clsx(classes.tableRow, { [classes.united]: united })}>
      <div className={clsx(classes.cell, classes.label)}>{label}</div>
      <div className={clsx(classes.cell, classes.value)}>{value || DASH}</div>
    </div>
  );
};

export default React.memo(WorkoutAnalysisTableRow);
